webpackJsonp([112587981740051,203888574390103,170386133984421,1987382413359,150791081430374,24723622855183,236036478720852],{

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = SecurityCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _securityCardModule = __webpack_require__(740);
	
	var _securityCardModule2 = _interopRequireDefault(_securityCardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _securityCardModule2.default));
	
	var bgValues = ['teal', 'marvel', 'purple--l', 'orange--l', 'yellow--l', 'purple'];
	
	function SecurityCard(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      color = _ref.color,
	      raised = _ref.raised,
	      image = _ref.image;
	
	  var blockClasses = cx('flex', { raised: raised });
	  var circleClasses = cx('bg-' + color, 'circle');
	  return _react2.default.createElement(
	    'div',
	    { className: blockClasses },
	    _react2.default.createElement(
	      'div',
	      { className: circleClasses },
	      _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _securityCardModule2.default.content },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'left' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'xxs', type: 'margin', position: 'bottom' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h3', weight: 'bold', size: 'm', color: 'black' },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'silver' },
	          subtitle
	        )
	      )
	    )
	  );
	}
	
	SecurityCard.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  raised: _propTypes2.default.bool,
	  color: _propTypes2.default.oneOf(bgValues).isRequired,
	  subtitle: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Security;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _assets = __webpack_require__(62);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _ArrowLink = __webpack_require__(75);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _SecurityCard = __webpack_require__(607);
	
	var _SecurityCard2 = _interopRequireDefault(_SecurityCard);
	
	var _securityModule = __webpack_require__(741);
	
	var _securityModule2 = _interopRequireDefault(_securityModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Security() {
	  return _react2.default.createElement(
	    'div',
	    { className: _securityModule2.default.main },
	    _react2.default.createElement(
	      'div',
	      { className: _securityModule2.default.wrap },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 620 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'black' },
	            'Your security and compliance needs covered'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 550 },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { size: 'l' },
	            'Marvel Enterprise provides above industry standard security to protect your work and data. We are EU hosted, GDPR compliant and provide enhanced protection features such as Single Sign-On and access locks to secure projects.'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'm', type: 'margin', position: 'top' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/security' },
	            _react2.default.createElement(
	              _ArrowLink2.default,
	              { size: 'l', weight: 'semibold' },
	              'Read more about Security'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 3, alignItems: 'flex-end', size: 'l' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'Activity log exports',
	            subtitle: 'Keep an offline record of Marvel activity so you can refer back to it any time you need to',
	            color: 'yellow--l',
	            image: _assets2.default.logoLog,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'GDPR compliant',
	            subtitle: 'We\'re committed to meeting our legal obligation and protecting the data rights of our customers',
	            color: 'purple',
	            image: _assets2.default.logoEU
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'SAML-based SSO',
	            subtitle: 'Marvel Enterprise gives your business several layers of security to their accounts',
	            color: 'orange--l',
	            image: _assets2.default.logoSaml,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'IP Restriction & granular access',
	            subtitle: 'Restrict access by ensuring only users on a specific IP address can access your Marvel account',
	            color: 'marvel',
	            image: _assets2.default.logoGlobe
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: '99.98% Uptime SLA',
	            subtitle: 'Our distributed infrastructure means you get the best and most reliable experience possible',
	            color: 'purple--l',
	            image: _assets2.default.logoArrow,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'EU Hosted Infrastructure',
	            subtitle: 'Our data center maintains multiple certifications including SOC1, SOC 2, SOC 3, ISO27001',
	            color: 'teal',
	            image: _assets2.default.logoMap
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-SecuritySection-style----security-card-module---flex---3bupV display-flex borderRadius-l","raised":"src-components-modules-SecuritySection-style----security-card-module---raised---1jkDg bg-snow","circle":"src-components-modules-SecuritySection-style----security-card-module---circle---1iacp marginRight-m display-block overflow-hidden borderRadius-circle","content":"src-components-modules-SecuritySection-style----security-card-module---content---12LY- flex-1"};

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components-modules-SecuritySection-style----security-module---main---y3eDE textAlign-center paddingTopBottom-xl","wrap":"src-components-modules-SecuritySection-style----security-module---wrap---1vr8p pageWrap c-black textAlign-center pageWrap-l"};

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Experience;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _assets = __webpack_require__(62);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _ExperienceCard = __webpack_require__(230);
	
	var _ExperienceCard2 = _interopRequireDefault(_ExperienceCard);
	
	var _experienceModule = __webpack_require__(748);
	
	var _experienceModule2 = _interopRequireDefault(_experienceModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Experience() {
	  return _react2.default.createElement(
	    'div',
	    { className: _experienceModule2.default.main },
	    _react2.default.createElement(
	      'div',
	      { className: _experienceModule2.default.wrap },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 800 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'black' },
	            'A customer experience you\u2019ll love'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 3, alignItems: 'stretch', size: 'l' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_ExperienceCard2.default, {
	            title: 'Your design partner now, and in the future',
	            subtitle: 'We help you understand the business value of design and drive transformation from the inside out. Our close customer relationships help us shape the future of the product and tailor solutions for your needs.',
	            image: _assets2.default.design
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_ExperienceCard2.default, {
	            title: 'Around the clock support from day one',
	            subtitle: 'Our friendly Customer Support and Experience team is on hand from day one to help brilliant companies like yours get up and running with the answers, training and resources you need.',
	            image: _assets2.default.support
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_ExperienceCard2.default, {
	            title: 'Scalable pricing that makes sense, no surprises',
	            subtitle: 'Our product drops jaws, not our pricing. It doesn\'t matter if you\'re starting to grow your team or transforming your business, our pricing structure is fair and based on how your teams operate.',
	            image: _assets2.default.scalable
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ExperienceCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExperienceCard(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      image = _ref.image;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 's', type: 'margin', position: 'topBottom' },
	      _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image))
	    ),
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 's', type: 'margin', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 340 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'semibold', size: 'xxl', color: 'black' },
	            title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _maxWidth2.default,
	        { value: 380 },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'black' },
	          subtitle
	        )
	      )
	    )
	  );
	}
	
	ExperienceCard.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired,
	  subtitle: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Header;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Video = __webpack_require__(465);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _assets = __webpack_require__(62);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _headerModule = __webpack_require__(749);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header() {
	  var icon = _react2.default.createElement(
	    'svg',
	    {
	      width: '11',
	      height: '13',
	      viewBox: '0 0 11 13',
	      xmlns: 'http://www.w3.org/2000/svg'
	    },
	    _react2.default.createElement('path', {
	      d: 'M10.656 6.016c.219.172.344.453.344.734 0 .281-.125.563-.344.75-.156.125-4.016 3.375-9.047 5.422-.125.047-.25.078-.391.078-.172 0-.359-.047-.516-.141-.266-.156-.453-.438-.469-.75-.016-.109-.234-2.641-.234-5.359 0-2.719.219-5.25.234-5.344.016-.313.203-.594.469-.766.156-.094.328-.141.516-.141.125 0 .266.031.391.078 5.031 2.047 8.891 5.297 9.047 5.438z',
	      fill: '#0C1014'
	    })
	  );
	
	  var buttons = _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeM: 'l', position: 'top', type: 'margin' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.buttons },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.leftButton },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/enterprise/request-demo' },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              size: 'large',
	              background: 'blue',
	              hover: 'blue',
	              shape: 'rounded',
	              minWidth: 180
	            },
	            'Request a demo'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.rightButton },
	        _react2.default.createElement(_Video2.default, {
	          id: 'ijlaqk4xz2',
	          childButton: _react2.default.createElement(
	            'div',
	            { className: _headerModule2.default.hackyButton },
	            _react2.default.createElement(
	              _button2.default,
	              {
	                size: 'large',
	                kind: 'ghost',
	                hover: 'green',
	                shape: 'rounded',
	                icon: icon,
	                minWidth: 180,
	                isIconCentered: true
	              },
	              'Watch video'
	            )
	          )
	        })
	      )
	    )
	  );
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.flex },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.firstCol },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', size: 'xxxxl', weight: 'bold', color: 'black' },
	            'Design, test and ship amazing products at scale with Marvel'
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 's', position: 'top', type: 'margin' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h2', size: 'xxl' },
	              'Marvel Enterprise transforms your design process, leading to better products, faster.'
	            )
	          ),
	          buttons
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.secondCol },
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.blueBackground },
	          _react2.default.createElement('div', { className: _headerModule2.default.blueChild })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.image },
	          _react2.default.createElement(
	            'div',
	            { className: _headerModule2.default.imageChild },
	            _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.dashboard, { hasShadow: false, block: true }))
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Logos;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logoRow = __webpack_require__(53);
	
	var _logoRow2 = _interopRequireDefault(_logoRow);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _logos = __webpack_require__(473);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _ArrowLink = __webpack_require__(75);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _logosModule = __webpack_require__(750);
	
	var _logosModule2 = _interopRequireDefault(_logosModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logos() {
	  return _react2.default.createElement(
	    'div',
	    { className: _logosModule2.default.flex },
	    _react2.default.createElement(_logoRow2.default, {
	      logos: _logos2.default,
	      align: 'center',
	      color: 'black',
	      opacity: 100,
	      spacing: 'm'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _logosModule2.default.cta },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/customer-stories' },
	          _react2.default.createElement(
	            _ArrowLink2.default,
	            { size: 'm', weight: 'semibold', colour: 'black' },
	            'Read case studies'
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Try;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(62);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _tryModule = __webpack_require__(751);
	
	var _tryModule2 = _interopRequireDefault(_tryModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Try() {
	  return _react2.default.createElement(
	    'div',
	    { className: _tryModule2.default.main },
	    _react2.default.createElement(
	      'div',
	      { className: _tryModule2.default.wrap },
	      _react2.default.createElement(
	        'div',
	        { className: _tryModule2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _tryModule2.default.left },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'white' },
	            'Ready to try it out?'
	          ),
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 388 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xl', color: 'white' },
	              'Join thousands of large design teams and switch to Marvel Enterprise 3'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', type: 'margin', position: 'top' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/enterprise/request-demo' },
	              _react2.default.createElement(
	                _button2.default,
	                {
	                  size: 'extraLarge',
	                  color: 'slate',
	                  hover: 'white',
	                  background: 'white',
	                  shape: 'rounded'
	                },
	                'Request a demo'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _tryModule2.default.right },
	          _react2.default.createElement(
	            'div',
	            { className: _tryModule2.default.imageChild },
	            _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, _assets2.default.imageEditor, { block: true }))
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = VideoBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _SmartVideo = __webpack_require__(609);
	
	var _SmartVideo2 = _interopRequireDefault(_SmartVideo);
	
	var _RevealWrapper = __webpack_require__(57);
	
	var _RevealWrapper2 = _interopRequireDefault(_RevealWrapper);
	
	var _blockModule = __webpack_require__(747);
	
	var _blockModule2 = _interopRequireDefault(_blockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _blockModule2.default));
	
	function VideoBlock(_ref) {
	  var title = _ref.title,
	      copy = _ref.copy,
	      isRightAligned = _ref.isRightAligned,
	      cloudinaryId = _ref.cloudinaryId,
	      poster = _ref.poster,
	      maxVideoWidth = _ref.maxVideoWidth,
	      headingMaxWidth = _ref.headingMaxWidth,
	      paragraphMaxWidth = _ref.paragraphMaxWidth;
	
	  var flexClasses = cx('flex', { reverse: isRightAligned });
	
	  return _react2.default.createElement(
	    _RevealWrapper2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: flexClasses },
	      _react2.default.createElement(
	        'div',
	        { className: _blockModule2.default.content },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: maxVideoWidth },
	          _react2.default.createElement(_SmartVideo2.default, {
	            name: cloudinaryId,
	            autoPlay: true,
	            loop: true,
	            muted: true,
	            quality: 95,
	            maxWidth: maxVideoWidth,
	            customPoster: poster
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _blockModule2.default.text },
	        _react2.default.createElement(
	          _HeadingBlock2.default,
	          {
	            justify: 'center',
	            maxWidth: paragraphMaxWidth,
	            headingMaxWidth: headingMaxWidth,
	            title: title,
	            copy: copy,
	            headingSize: 'xxxl',
	            paragraphSize: 'l',
	            spacing: 's',
	            tag: 'h3'
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/enterprise/request-demo' },
	            _react2.default.createElement(
	              _button2.default,
	              { size: 'large', kind: 'ghost', hover: 'blue', shape: 'rounded' },
	              'Request a demo'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	VideoBlock.propTypes = {
	  copy: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  poster: _propTypes2.default.string,
	  cloudinaryId: _propTypes2.default.string,
	  maxVideoWidth: _propTypes2.default.number,
	  headingMaxWidth: _propTypes2.default.number,
	  paragraphMaxWidth: _propTypes2.default.number,
	  isRightAligned: _propTypes2.default.bool
	};
	
	VideoBlock.defaultProps = {
	  isRightAligned: false
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Enterprise;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _SecuritySection = __webpack_require__(608);
	
	var _SecuritySection2 = _interopRequireDefault(_SecuritySection);
	
	var _ImageBlock = __webpack_require__(149);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _assets = __webpack_require__(62);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _Header = __webpack_require__(644);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Logos = __webpack_require__(645);
	
	var _Logos2 = _interopRequireDefault(_Logos);
	
	var _VideoBlock = __webpack_require__(647);
	
	var _VideoBlock2 = _interopRequireDefault(_VideoBlock);
	
	var _Experience = __webpack_require__(643);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _Try = __webpack_require__(646);
	
	var _Try2 = _interopRequireDefault(_Try);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var facebookMeta = [{
	  name: 'og:title',
	  content: 'The Platform for Large Teams to Scale Design'
	}, {
	  name: 'og:site_name',
	  content: 'Marvel Enterprise'
	}, {
	  name: 'og:type',
	  content: 'website'
	}, {
	  name: 'og:url',
	  content: 'https://marvelapp.com/enterprise'
	}, {
	  name: 'og:description',
	  content: 'Join thousands of teams switching to Marvel Enterprise 3. The all new platform built so you can create amazing products at scale.'
	}, {
	  name: 'og:image',
	  content: 'https://marvelapp.com' + _assets2.default.sharePreview.src
	}, {
	  name: 'og:site_name',
	  content: 'Marvel Enterprise'
	}];
	
	var twitterMeta = [{
	  name: 'twitter:site',
	  content: 'https://marvelapp.com/enterprise'
	}, {
	  name: 'twitter:creator',
	  content: 'Marvel Enterprise'
	}, {
	  name: 'twitter:title',
	  content: 'The Platform for Large Teams to Scale Design'
	}, {
	  name: 'twitter:image',
	  content: 'https://marvelapp.com' + _assets2.default.sharePreview.src
	}];
	
	var meta = {
	  title: 'Marvel Enterprise | The Design, Prototyping and User Testing Platform for Large Teams to Scale Design',
	  meta: [{
	    name: 'description',
	    content: _metadata2.default.enterprise.description
	  }, {
	    name: 'keywords',
	    content: _metadata2.default.enterprise.keywords
	  }].concat(twitterMeta, facebookMeta),
	  header: { isLight: false },
	  footer: true
	};
	
	function Enterprise() {
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(_Logos2.default, null),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Seamlessly move from prototype to user test to developer handoff',
	      copy: 'Consolidate your tools and give every team the power to problem solve together. Brainstorm, design, prototype, user test and handoff to developers on a single platform, accessible by designers, developers, researchers and stakeholders in a few clicks.',
	      headingMaxWidth: 390,
	      paragraphMaxWidth: 480,
	      imageAsset: _assets2.default.posterFeatures
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Effortlessly organise your work, design systems and documentation',
	      copy: 'Folders make it easy to bunch together related ideas, prototypes and user test results with external links to your design systems, documentation and tasks - so you can share a single URL with your team, developers or wider stakeholders.',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.organise,
	      isRightAligned: true
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      title: 'Full visibility of new, ongoing and completed projects ',
	      copy: 'Whether it\'s what\'s new, what\'s in progress or what\'s finished, Marvel Enterprise centralises all team members activity into one stream, so management can quickly see what\'s in motion and stay on the same page.',
	      headingMaxWidth: 458,
	      paragraphMaxWidth: 458,
	      imageAsset: _assets2.default.team
	    }),
	    _react2.default.createElement(_VideoBlock2.default, {
	      title: 'Integrate, automate or build with your favourite tools ',
	      copy: 'We know that every workflow is different, that\'s why Marvel works with the likes of Sketch, JIRA, Slack and much more. If you need something more custom, our powerful GraphQL API allows you to roll your own workflows. No devs? No problem, Zapier integrates with over 1000+ apps and services.',
	      headingMaxWidth: 459,
	      paragraphMaxWidth: 459,
	      imageAsset: _assets2.default.organise,
	      isRightAligned: true,
	      poster: _assets2.default.brainstorm.src,
	      cloudinaryId: 'logos_animation',
	      maxVideoWidth: 642
	    }),
	    _react2.default.createElement(_SecuritySection2.default, null),
	    _react2.default.createElement(_Experience2.default, null),
	    _react2.default.createElement(_Try2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-pages-enterprise-style----block-module---flex---3SG56 alignContent-center justifyContent-center pageWrap pageWrap-l paddingTopBottom-m breakPointM-paddingTopBottom-xl c-black textAlign-center display-block","reverse":"src-pages-enterprise-style----block-module---reverse---3pXPm","content":"src-pages-enterprise-style----block-module---content---MDhFS alignContent-center justifyContent-center width-100 display-flex","text":"src-pages-enterprise-style----block-module---text---1fgpN alignContent-center justifyContent-center width-100 marginTop-l breakPointM-marginTop-0 display-flex"};

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-pages-enterprise-style----experience-module---main---3QimN textAlign-center paddingTopBottom-xl","wrap":"src-pages-enterprise-style----experience-module---wrap---3fg22 pageWrap c-black textAlign-center pageWrap-l"};

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-pages-enterprise-style----header-module---flex---1vUMJ alignItems-stretch justifyContent-center marginBottom-xl breakPointM-display-flex breakPointM-textAlign-left","firstCol":"src-pages-enterprise-style----header-module---firstCol---1q7FV breakPointM-marginBottom-0 breakPointM-marginRight-l breakPointM-textAlign-left textAlign-center marginBottom-l justifyContent-center marginRight-0","buttons":"src-pages-enterprise-style----header-module---buttons---otaGx breakPointM-flexDirection-row flexDirection-column justifyContent-start display-flex","leftButton":"src-pages-enterprise-style----header-module---leftButton---22GyY breakPointM-paddingRight-xxs breakPointM-paddingBottom-0 paddingBottom-xs","rightButton":"src-pages-enterprise-style----header-module---rightButton---1eS17 breakPointM-paddingLeft-xxs","secondCol":"src-pages-enterprise-style----header-module---secondCol---3AHTD","blueBackground":"src-pages-enterprise-style----header-module---blueBackground---LTx20","blueChild":"src-pages-enterprise-style----header-module---blueChild---fedIX","blueBackgroundAnimation":"src-pages-enterprise-style----header-module---blueBackgroundAnimation---P2aSJ","image":"src-pages-enterprise-style----header-module---image---3ymZ1","imageChild":"src-pages-enterprise-style----header-module---imageChild---nZnzS bg-white","imageAnimation":"src-pages-enterprise-style----header-module---imageAnimation---2ht35","hackyButton":"src-pages-enterprise-style----header-module---hackyButton---1l7cc"};

/***/ }),

/***/ 750:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-pages-enterprise-style----logos-module---flex---T-P41 alignItems-center justifyContent-center breakPointL-display-flex breakPointL-textAlign-left","cta":"src-pages-enterprise-style----logos-module---cta---2Z4jM paddingTop-l breakPointL-paddingLeft-m breakPointL-paddingTop-0"};

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-pages-enterprise-style----try-module---main---31n4V textAlign-center paddingTopBottom-xl","container":"src-pages-enterprise-style----try-module---container---1j5ix position-relative centered breakPointM-display-flex breakPointM-textAlign-left textAlign-center bg-marvel","left":"src-pages-enterprise-style----try-module---left---llhzI breakPointM-padding-xl paddingBottom-l paddingTop-xl","right":"src-pages-enterprise-style----try-module---right---1IUS_ paddingBottom-xl paddingLeftRight-l breakPointM-paddingBottom-0 breakPointM-paddingLeft-0 breakPointM-paddingRight-xl","imageChild":"src-pages-enterprise-style----try-module---imageChild---3jh8I","imageAnimation":"src-pages-enterprise-style----try-module---imageAnimation---1nJIs","wrap":"src-pages-enterprise-style----try-module---wrap---31IAk pageWrap c-black textAlign-center pageWrap-l"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-enterprise-index-js-1d49f09ec7633f988921.js